type Breakpoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

const SPACING_UNIT = 8;

export const styles = {
  breakpoints: {
    down: (viewport: Breakpoints) => {
      switch (viewport) {
        case 'xs':
          return '@media (max-width: 599.95px)';
        case 'sm':
          return '@media (max-width: 959.95px)';
        case 'md':
          return '@media (max-width: 1279.95px)';
        case 'lg':
          return '@media (max-width: 1919.95px)';
        case 'xl':
          return '@media (min-width:0px)';
        default:
          return '';
      }
    },
    up: (viewport: Breakpoints) => {
      switch (viewport) {
        case 'xs':
          return '@media (min-width:0px)';
        case 'sm':
          return '@media (min-width:600px)';
        case 'md':
          return '@media (min-width:960px)';
        case 'lg':
          return '@media (min-width:1280px)';
        case 'xl':
          return '@media (min-width:1920px)';
        default:
          return '';
      }
    },
    only: (viewport: Breakpoints) => {
      switch (viewport) {
        case 'xs':
          return '@media (min-width:0px) and (max-width:599.95px)';
        case 'sm':
          return '@media (min-width:600px) and (max-width:959.95px)';
        case 'md':
          return '@media (min-width:960px) and (max-width:1279.95px)';
        case 'lg':
          return '@media (min-width:1280px) and (max-width:1919.95px)';
        case 'xl':
          return '@media (min-width:1920px)';
        default:
          return '';
      }
    },
  },
  fonts: {
    primary: 'GT Walsheim, sans-serif',
    secondary: 'Roboto, sans-serif',
  },
  palette: {
    background: {
      paper: '#fff',
      primary: '#05a0d9',
      primaryDark: '#02719a',
      primaryIntensive: '#0a58ca',
      dark: '#2c404f',
      light: '#f8fafb',
    },
    text: {
      primary: '#212529',
      primary500: '#2c404f', // TODO: find out new palette
      primary600: '#39424b',
      inverse: '#fff',
      secondary: '#05a0d9',
      secondaryDark: '#02719a',
      secondaryIntensive: '#0a58ca',
    },
  },
  shadows: {
    intensive:
      '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
    regular: '0 20px 40px 0 rgb(3 0 77 / 10%)',
  },
  spacing: (times: number) => `${SPACING_UNIT * times}`,
  transitions: {
    regular: (properties: string[]) =>
      properties.map((property) => `${property} 0.3s ease`).join(', '),
  },
};
